const initialState = {
  isProfB1DataLoaded: false,
  dateReceivedCDC: '',
  lengthOfTermInYrsAndMos: '',
  secondStrike: '',
  commitmentOffenses: '',
  expectedPrisonReleaseDate: '',
  controllingDischargeDate: '',
  comments: '',
  releaseDate: '',
  controllingDchDate: '',
  EPRD: '',
  RRD: '',
  PED: '',
  CDD: '',
  CDD_MAX: '',
  highControlSupervision: '',
  h11590NarcoticRegistration: '',
  pC296ViolentOrSeriousOffenderNotification: '',
  city: '',
  paroleRegion: '',
  historyOfConvictions: '',
  rSuffixInCentralFile: '',
  rSuffixExplination: '',
  countyOfLastLegalResidence: {
    id: '',
    value: '',
  },
  participant: {
    p290SexRegistration: '',
    p457_1ArsonRegistration: '',
  },
  lengthOfTermInYrs: '',
  lengthOfTermInMos: '',
};
export default initialState;
